import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-between gap-4 items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " Application List ", -1)
const _hoisted_3 = { class: "mt-4 w-full overflow-x-auto" }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 max-w-screen-md space-y-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "This page is unique to your email address."),
    /*#__PURE__*/_createTextVNode(" If you bookmark this page you can return to the page without going through the email verification step. "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, " Please only share this link with people who you want seeing all your applications. ")
  ]),
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Please Note: All inspections must be called in at "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "link",
      href: "tel:608-459-880"
    }, "608-459-8800"),
    /*#__PURE__*/_createTextVNode(" or requested directly in the payment portal once the permit fee is paid. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " By clicking the \"View Permit\" button on the application in the table above you can view the details of the permit and request an inspection time. ")
], -1)

import api from '@/utilities/api'

	import {
		PlusIcon
	} from '@heroicons/vue/20/solid'

	import {
		onMounted,
		ref
	} from 'vue'

	import {
		useRoute
	} from 'vue-router'

	
	const __default__ = { name: 'ApplicationList' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const route = useRoute()
	const query = route.query
	const id = query?.id || ""
	const type = query?.type || ""
	const loading = ref(false)
	const applications = ref([])
	const sortColumn = ref('datePermitted')
	const sortOrder = ref('DESC')

	onMounted(async () => {
		try { // loading list of permits 
			loading.value = true
			let payload = {
				id: id,
				type: type
			}
	
			const body = {
				action: "getApplicationList",
				payload: payload,
			}
	
			const response = await api("post", "fmDataApi", "/fm-data-api", body)
			let allApplications = JSON.parse(response.response.scriptResult).result.data
			applications.value = allApplications.filter(application => {
				return application.status !== "Cancelled" && application.status !== "Omitted"
			})
			sortMethod('DESC', 'dateSubmitted')
			sortMethod(sortOrder.value, sortColumn.value)
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	})

	function sortMethod(order: string, field: string) {
		applications.value.sort((a,b) => {
			if(order === 'ASC') return ('' + a[field]).localeCompare(b[field], undefined,{numeric: true})
			else if(order === 'DESC') return ('' + b[field]).localeCompare(a[field], undefined,{numeric: true})
			else return ('' + a[field]).localeCompare(b[field], undefined,{numeric: true})
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_router_link, { to: {name: 'ApplicationForm'} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            class: "w-auto mx-auto",
            color: "amber"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PlusIcon)),
              _createTextVNode(" New Application ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tw_table, {
        data: applications.value,
        loading: loading.value,
        placholder: "No permits found",
        "default-sort": {prop: 'datePermitted', order: 'DESC'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: "Address",
            prop: "address",
            "class-name": "!w-64",
            "header-class-name": "!w-64"
          }),
          _createVNode(_component_tw_table_column, {
            header: "Status",
            prop: "status",
            sortable: "",
            "class-name": "!w-24",
            "header-class-name": "!w-24",
            "sort-method": ( sortDirection ) => { sortMethod(sortDirection, 'status') }
          }, null, 8, ["sort-method"]),
          _createVNode(_component_tw_table_column, {
            header: "Type",
            prop: "type",
            sortable: "",
            "class-name": "!w-36",
            "header-class-name": "!w-36",
            "sort-method": ( sortDirection ) => { sortMethod(sortDirection, 'type') }
          }, null, 8, ["sort-method"]),
          _createVNode(_component_tw_table_column, {
            header: "Date Submitted",
            prop: "dateSubmitted",
            sortable: "",
            "class-name": "!w-36",
            "header-class-name": "!w-36",
            "sort-method": ( sortDirection ) => { sortMethod(sortDirection, 'dateSubmitted') }
          }, null, 8, ["sort-method"]),
          _createVNode(_component_tw_table_column, {
            header: "Permit No.",
            prop: "permitNumber",
            "class-name": "!w-32",
            "header-class-name": "!w-32",
            sortable: "",
            "sort-method": ( sortDirection ) => { sortMethod(sortDirection, 'permitNumber') }
          }, null, 8, ["sort-method"]),
          _createVNode(_component_tw_table_column, {
            header: "Date Permitted",
            prop: "datePermitted",
            sortable: "",
            "class-name": "!w-36",
            "header-class-name": "!w-36",
            "sort-method": ( sortDirection ) => { sortMethod(sortDirection, 'datePermitted') }
          }, null, 8, ["sort-method"]),
          _createVNode(_component_tw_table_column, {
            header: "View permit or application",
            "header-class-name": "sr-only !w-40",
            "class-name": "!w-40",
            align: "left"
          }, {
            default: _withCtx(({row}) => [
              _createElementVNode("div", _hoisted_4, [
                (row.permitID)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'PermitDetails', query: {id: row.permitID}}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_button, {
                          class: "w-34",
                          color: "white",
                          size: "sm"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View Permit ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (row.status.toLowerCase() === 'draft')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: {name: 'ApplicationForm', query: {id: row.id}}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_button, {
                            class: "w-34",
                            color: "white",
                            size: "sm"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit Draft ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: {name: 'ApplicationForm', query: {id: row.id}}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_button, {
                            class: "w-34",
                            color: "white",
                            size: "sm"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" View Application ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "loading"]),
      _hoisted_5
    ])
  ], 64))
}
}

})